export default __webpack_public_path__ + "static/media/inspirasi-terkini1.75647fc1.png";